import { render, staticRenderFns } from "./FeaturesView.vue?vue&type=template&id=352f645a&scoped=true"
import script from "./FeaturesView.vue?vue&type=script&lang=js"
export * from "./FeaturesView.vue?vue&type=script&lang=js"
import style0 from "./FeaturesView.vue?vue&type=style&index=0&id=352f645a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352f645a",
  null
  
)

export default component.exports